"use strict";
/// <reference path="../../../../Trillium.UI/TypeScript/Models/Website/PartnerPodsComponentViewModel.tsx"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var PartnerPodsItem_1 = __importDefault(require("../PartnerPodsComponent/PartnerPodsItem"));
var PartnerPodComponent = /** @class */ (function (_super) {
    __extends(PartnerPodComponent, _super);
    function PartnerPodComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PartnerPodComponent.prototype.render = function () {
        return (react_1.default.createElement("div", { className: "pb-40" },
            react_1.default.createElement("div", { dangerouslySetInnerHTML: { __html: this.props.Description } }),
            react_1.default.createElement("div", { className: "row podRow" }, this.props.Items.map(function (item, i) {
                return react_1.default.createElement(PartnerPodsItem_1.default, { key: item.UniqueKey, UniqueKey: item.UniqueKey, ParentUniqueKey: item.ParentUniqueKey, Title: item.Title, Content: item.Content, LinkTitle: item.LinkTitle, LinkUrl: item.LinkUrl, ImageAltText: item.ImageAltText, ImageUrl: item.ImageUrl });
            }))));
    };
    return PartnerPodComponent;
}(react_1.Component));
exports.default = PartnerPodComponent;
